import styled from "styled-components";
import { tablet } from "@shared/ui/atoms/MediaQueries";

// Vertical space consumed above the whereabouts page: the Teams shell header,
// or the app's global header (which can be scrolled away).
export function whereaboutsHeaderOffset(isInTeams: boolean, headerCollapsed?: boolean): string {
  return isInTeams ? '65px' : (headerCollapsed ? '0px' : '114px');
}

export function whereaboutsViewportHeight(isInTeams: boolean, headerCollapsed?: boolean): string {
  return `calc(100vh - ${whereaboutsHeaderOffset(isInTeams, headerCollapsed)})`;
}

export const MainWhereaboutsContent = styled.div<{ $sidebarOpen?: boolean; $notesPanelOpen?: boolean }>`
  transition: max-width 0.25s ease;
  width: 100%;
  @media (${tablet}) {
    max-width: ${props => {
      let sideBarWidth = 80;
      if (props.$sidebarOpen) sideBarWidth = 360;
      if (props.$notesPanelOpen) sideBarWidth += 320;
      return `min(calc(min(100vw, 1400px) + ((100vw - min(100vw, 1400px)) / 2) - ${sideBarWidth}px), min(100vw, 1400px))`;
    }};
  }
  position: relative;
  margin: 0 auto;
`
